import { useState, useEffect } from 'react';
import { createModel } from 'hox';
import { ISCMPoGoodsDetail, ISCMPoFormFields, ISCMPoDescType } from './scmPurchasePoType';
import { useGlobalModel } from '@/model/globalModel';
import { purchasePoService } from './scmPurchasePoService';
import { DictCodeEnmu } from '@/types/FmsDictEnums';
import { useScmSaleRoDetailModel } from '../scmSaleRo/scmSaleRoModel';

const initDesc = {
	actualAmount: 0, //实际总价合计 （数量*单价）

	//对应展示字段
	numAll: 0, //开单
	giftsAll: 0, //赠品
	damageAll: 0, //损坏
	kindAll: 0, //种类
	stockInAll: 0, //已入库
	rejectAll: 0, //驳回
	amountAll: 0, //总计   （去除下浮，赠品的金额）
	stockAmountAll: 0, //入库总计   （去除下浮）
	giftsAmount: 0, //赠品总计
	settleAmountAll: 0, //入库总计
};

export const usePurchasePoDetailsModel = createModel(function () {
	const {
		user: { shopId, shopName, userName },
	} = useGlobalModel();

	const { getTreeNodeName } = useScmSaleRoDetailModel();

	const initFormVal = {
		shopName,
		createUser: userName,
		operator: userName,
		purchaseCode: '', //采购单编码
		status: '', //采购单状态
		favorableAmount: '0', //整单优惠
		discountTotalAmount: '0.00', //优惠总额
		paidAmount: '0.00', //已付金额
		totalAmount: '0.00', //应付金额
		discountRate: '0', //整单下浮
		stockIoTotalAmount: '0.00', //入库金额
		purchaseTypeCode: '', //默认常规类型
		purchaseTypeName: '非直发', //默认常规类型
	} as ISCMPoFormFields;

	//查看缓存
	const [lookFormVal, setLookFormVal] = useState<ISCMPoFormFields>(initFormVal);
	const [lookGoodsList, setLookGoodsList] = useState<ISCMPoGoodsDetail[]>([]);
	const [lookDesc, setLookDesc] = useState<ISCMPoDescType>(initDesc);
	const [lookIsDirect, setLookIsDirect] = useState<boolean>(false);

	useEffect(() => {
		let newDesc: ISCMPoDescType = { ...initDesc };
		lookGoodsList.forEach((item) => {
			newDesc.numAll += Number(item.num);
			newDesc.giftsAll += Number(item.giftsNum);
			newDesc.damageAll += Number(item.damageNum);
			newDesc.stockInAll += Number(item.stockIoNum);
			newDesc.rejectAll += Number(item.rejectNum);
			newDesc.amountAll += Number(item.amount);
			newDesc.actualAmount += Number(item.num) * Number(item.price);
			newDesc.stockAmountAll += Number(item.stockIoAmount);
			newDesc.settleAmountAll += Number(item.settleIoAmount);
			newDesc.giftsAmount += +Number(item.giftsNum) * +(item.price ?? 0);
		});
		newDesc.kindAll = new Set(lookGoodsList.map((item) => item.materialCode)).size ?? 0;
		setLookDesc(newDesc);
	}, [lookGoodsList]);

	useEffect(() => {
		resetLookCatch();
		setLookFormVal({ ...initFormVal, shopId, shopName, createUser: userName });
	}, [shopId]);

	//重置缓存
	const resetLookCatch = () => {
		setLookFormVal(initFormVal);
		setLookGoodsList([]);
	};

	//获取一条数据
	const getPoDetailOne = async (id: string) => {
		let { retData } = await purchasePoService.one(id);
		if (retData) {
			let { details, ...formVal } = retData;
			setLookGoodsList(() =>
				details.map((item) => ({
					...item,
					key: item.id,
					isShelfCode: item.shelfCode ? true : false,
				}))
			);
			setLookFormVal({
				...formVal,
				purchaseTypeName: getTreeNodeName(formVal.purchaseTypeCode),
				brandName: getTreeNodeName(formVal.brandCode),
				supplierTypeName: getTreeNodeName(formVal.supplierTypeCode),
				invoiceTypeName: getTreeNodeName(formVal.invoiceTypeCode),
				preferentialTypeName: getTreeNodeName(formVal.preferentialTypeCode),
			});
			setLookIsDirect(retData.purchaseTypeCode === 'PURCHASE_TYPE_DIRECT' ? true : false); //判断直发类型
		}
	};

	return {
		lookFormVal,
		lookGoodsList,
		setLookGoodsList,
		lookDesc,
		resetLookCatch,
		getPoDetailOne,
		lookIsDirect,
		setLookIsDirect,
	};
});
